module.exports = __webpack_public_path__ + "img/LOGO DIRECT.b563aade.png";